/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import helpers from '../base/helpers';
import can from 'can';
import dtm from 'scripts/services/dtm';
import BrightcoveService from 'scripts/services/brightcove-service';
import template from './video.stache';

const pageType = window.globalSettings.pageType;

Component.extend({
    tag: 'card-video',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            card: {
                Type: can.Map,
                Value: null
            },
            activeCard: {
                Type: can.Map,
                Value: null
            },
            isActiveCard: {
                type: 'boolean',
                get() {
                    const card = this.attr('card');
                    const activeCard = this.attr('activeCard');
                    return card && activeCard && card.identifier === activeCard.identifier;
                }
            },
            isgscard: {
                type: 'boolean',
                Value: null
            },
            analyticsVideoSource: {
                type: 'string',
                get() {
                    switch (pageType) {
                        case 'player-detail' :
                            return 'Player Detail Latest Feed';
                        case 'latest':
                            return 'Home Latest Feed Inline';
                        default:
                            return '';
                    }
                }
            },
            image: {
                type: can.Map,
                get(lastVal) {
                    if (lastVal) {
                        return lastVal;
                    }
                    BrightcoveService.getVideo(this.attr('card.video.identifier')).then(data => {
                        this.attr('image', {
                            type: 'imageGeneric',
                            url: data.poster
                        });
                    });
                }
            }
        },
        onEnd() {
            dtm.trackTimelineVideoComplete();
        }
    },
    events: {
        inserted(element) {
            can.route.bind('section', (ev, tabIndex) => {
                this.viewModel.attr('activeCard', null);
            });

        },
        '.js-card-selector click'() {
            this.viewModel.attr('activeCard', this.viewModel.attr('card'));
        },
        '.s-preview-img, .js-card-selector click'() {
            dtm.trackTimelineVideoStart();
        },
        '.s-video-close-btn click'() {
            this.viewModel.attr('activeCard', null);
        }
    }
});
